import api from './api';

export const TurnoEnum = {
  MATUTINO: 'matutino',
  VESPERTINO: 'vespertino',
  NOTURNO: 'noturno',
  INTEGRAL: 'integral'
} as const;

export type TurnoEnum = typeof TurnoEnum[keyof typeof TurnoEnum];

export interface CreateTurmaDto {
  nome: string;
  serieId: number;
  turno: TurnoEnum;
  ano: number;
  valorMensalidade: number;
  ativa?: boolean;
}

export interface UpdateTurmaDto {
  nome?: string;
  serieId?: number;
  turno?: TurnoEnum;
  ano?: number;
  valorMensalidade?: number;
  ativa?: boolean;
}

export interface TurmaResponse {
  id: number;
  nome: string;
  serie: string;
  serieId?: number | null;
  turno: TurnoEnum;
  ano: number;
  valorMensalidade: number;
  valorMaterialDidatico?: number;
  ativa: boolean;
  codigoServicoId?: number | null;
  codigoServico?: {
    id: number;
    codigoAtividade: string;
    codigoServico: string;
    descricao: string;
    tipo?: string | null;
    ativo: boolean;
  } | null;
  totalAlunos?: number;
  criadoEm: string;
  atualizadoEm: string;
}

export const turmasService = {
  // Criar turma
  async create(data: CreateTurmaDto): Promise<TurmaResponse> {
    const response = await api.post<TurmaResponse>('/turmas', data);
    return response.data;
  },

  // Listar todas as turmas
  async findAll(ano?: number): Promise<TurmaResponse[]> {
    const params = ano ? { ano: ano.toString() } : {};
    const response = await api.get<TurmaResponse[]>('/turmas', { params });
    return response.data;
  },

  // Buscar turma por ID
  async findById(id: number): Promise<TurmaResponse> {
    const response = await api.get<TurmaResponse>(`/turmas/${id}`);
    return response.data;
  },

  // Atualizar turma
  async update(id: number, data: UpdateTurmaDto): Promise<TurmaResponse> {
    const response = await api.patch<TurmaResponse>(`/turmas/${id}`, data);
    return response.data;
  },

  // Excluir turma
  async remove(id: number): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/turmas/${id}`);
    return response.data;
  },

  // Ativar/desativar turma
  async toggleActive(id: number): Promise<TurmaResponse> {
    const response = await api.patch<TurmaResponse>(`/turmas/${id}/toggle-active`);
    return response.data;
  },

  // Filtrar por ano
  async findByAno(ano: number): Promise<TurmaResponse[]> {
    return this.findAll(ano);
  },
};

export default turmasService;
